import { render, staticRenderFns } from "./ImageSwipers.vue?vue&type=template&id=15e727f1&scoped=true"
import script from "./ImageSwipers.vue?vue&type=script&lang=ts"
export * from "./ImageSwipers.vue?vue&type=script&lang=ts"
import style0 from "./ImageSwipers.vue?vue&type=style&index=0&id=15e727f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e727f1",
  null
  
)

export default component.exports